import * as React from 'react';
import { InputNumber } from 'antd';
import { FormWidgetItem } from './wrapper/FormWidgetItem';
import { IWidget } from 'common/schema/widget/Widget';
import { getWidgetInputText } from '../helper/getWidgetInputText';
import { NumberInput } from 'client/ui/form/input/NumberInput';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { useFormWidgetProps } from './contextual/useFormWidgetProps';

export interface FormWidgetInputNumericViewProps {
  widget: IWidget;
}

export function FormWidgetInputNumericView(
  props: FormWidgetInputNumericViewProps
) {
  const { widget } = props;

  // Abbiamo un singolo metadato
  const metadata = MetadataLogic.singleFromWidget(widget);
  const name = `values.${metadata.id}`;

  const [inputProps] = useFormWidgetProps(widget);

  return (
    <FormWidgetItem name={name} widget={props.widget}>
      <NumberInput
        name={name}
        placeholder={widget.input?.placeholder}
        decimalSeparator=","
        style={{ width: '100%' }}
        {...inputProps}
      />
    </FormWidgetItem>
  );
}
